import React from "react";
import Rightbarhome from "../rightbarhome/Rightbarhome";
import "./rightbar.scss";
import ProfileRightBar from "./../profileRightBar/ProfileRightBar";

// `profileUser` es la persona cuyo perfil se está viendo, que no siempre es
// la de la sesión: sin esto, al entrar al perfil de un compañero la barra
// lateral seguía mostrando tus propios datos.
const Rightbar = ({ profile, profileUser }) => {
  return (
    <div className="rightbar">
      <div className="rightbarWrapper">
        {profile ? <ProfileRightBar user={profileUser} /> : <Rightbarhome />}
      </div>
    </div>
  );
};

export default Rightbar;
